import { createFileRoute } from '@tanstack/react-router';
import { QuoteEditorPage } from '@/features/finance';

/** One quote: editor for a draft, read-only detail otherwise. Notification links open it. */
export const Route = createFileRoute('/_auth/o/$orgId/finance/quotes/$quoteId')({
  component: QuoteRoute,
});

function QuoteRoute() {
  const { orgId, quoteId } = Route.useParams();
  return <QuoteEditorPage orgId={orgId} quoteId={quoteId} />;
}
